import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { VoiceProvider } from "@/context/VoiceContext";
import Navbar from "@/components/Navbar";
import MicButton from "@/components/MicButton";
import AskAndrew from "@/components/AskAndrew";
import Home from "@/pages/Home";
import NotFound from "@/pages/NotFound";

function Shell() {
  const { pathname } = useLocation();
  const home = pathname === "/";
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      {home && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {home && <MicButton />}
      {home && <AskAndrew />}
    </>
  );
}

export default function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <VoiceProvider>
          <div className="film-grain" aria-hidden="true" />
          <Shell />
        </VoiceProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{ style: { background: "#18181C", color: "#F2EBDD", border: "1px solid rgba(201,165,74,0.4)", fontFamily: "Manrope, sans-serif" } }}
      />
    </ErrorBoundary>
  );
}
